import { render, staticRenderFns } from "./EffectConsult.vue?vue&type=template&id=1a49df39&lang=pug"
import script from "./EffectConsult.vue?vue&type=script&lang=js"
export * from "./EffectConsult.vue?vue&type=script&lang=js"
import style0 from "./EffectConsult.vue?vue&type=style&index=0&id=1a49df39&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports